console.log("Hello from gift.js!")

import "./application";
import '../utils/splide';
import '../apps/on_boarding/main';
import { OnBoardingGoal } from '../utils/models/OnBoardingGoal';
import { AuthMethods } from '../apps/on_boarding/store/modules/OnBoardingModule';

const giftButtons = document.querySelectorAll('.gift-checkout-btn');
giftButtons.forEach((button) => {
  button.addEventListener('click', function (e) {
    e.preventDefault();
    const btn = (e.currentTarget as HTMLElement);
    const duration = btn.getAttribute('data-duration') as '1_year' | '3_year' | '5_year';
    if (!window.user) {
      // Store selected duration for after login
      sessionStorage.setItem('selectedGiftDuration', duration);
      window.onBoardingVue.launchFor(OnBoardingGoal.CreateAccountForPurchase, [AuthMethods.Email, AuthMethods.Google, AuthMethods.Apple]);
    } else {
      window.location.href = window.giftCheckoutUrls[duration];
    }
  });
});

// Handle redirect after login
const storedDuration = sessionStorage.getItem('selectedGiftDuration') as '1_year' | '3_year' | '5_year' | null;
if (storedDuration && window.user && window.giftCheckoutUrls) {
  sessionStorage.removeItem('selectedGiftDuration');
  window.location.href = window.giftCheckoutUrls[storedDuration];
}
